import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  container: {
    backgroundColor: theme.palette.common.white,
    margin: '0 0 24px 0',
    borderRadius: 18,
    border: '1px solid rgba(16,24,40,0.07)',
    boxShadow:
      'inset 0 1px 0 rgba(255,255,255,0.9), 0 1px 2px rgba(16,24,40,0.06), 0 10px 28px -12px rgba(16,24,40,0.18)',
    backgroundImage: 'linear-gradient(180deg, #FFFFFF 0%, #FBFBFC 100%)',
    textAlign: 'left',
    overflow: 'hidden',
    paddingBottom: 0
  },
  heading: {
    backgroundColor: theme.palette.common.white,
    backgroundImage:
      'linear-gradient(180deg, rgba(255,241,233,0.75) 0%, rgba(255,255,255,0) 100%)',
    width: '100%',
    padding: '16px 24px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRadius: '16px 16px 0 0',
    textAlign: 'left'
  },
  // Editing wears the dark header, matching how Shop Types tells an edit
  // dialog apart from the create form on the page behind it.
  headingBlack: {
    backgroundColor: theme.palette.common.black,
    width: '50%',
    padding: 10,
    borderRadius: '20px 20px 20px 0',
    textAlign: 'center'
  },
  // Editing wears the dark header, matching how Shop Types tells an edit
  // dialog apart from the create form on the page behind it.
  headingBlack: {
    backgroundColor: theme.palette.common.black,
    width: '50%',
    padding: 10,
    borderRadius: '20px 20px 20px 0',
    textAlign: 'center'
  },
  text: {
    color: theme.palette.text.primary,
    fontSize: 16,
    fontWeight: 700
  },
  textWhite: {
    color: theme.palette.common.white,
    fontWeight: 'bold'
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  closeButton: {
    marginRight: 12
  },
  loadingBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    padding: 30
  },
  form: {
    margin: '4px 24px 24px 24px',
    alignItems: 'stretch',
    textAlign: 'left'
  },
  labelText: {
    textAlign: 'left',
    marginLeft: 0,
    fontSize: '13px',
    fontWeight: 600,
    color: theme.palette.text.disabled,
    marginTop: '16px'
  },
  helpText: {
    textAlign: 'left',
    marginLeft: '4%',
    fontSize: 13,
    opacity: 0.7
  },
  listWrapper: {
    marginLeft: '4%',
    marginRight: '4%',
    textAlign: 'left'
  },
  sourceRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: 10
  },
  sourceText: {
    fontSize: 13,
    opacity: 0.7
  },
  secondaryButton: {
    textTransform: 'none',
    fontSize: 12,
    marginLeft: 8
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: 8,
    marginBottom: 8,
    borderRadius: 10,
    border: '1px solid #E0E0E0',
    backgroundColor: theme.palette.common.white,
    // Without this the browser selects text instead of dragging
    userSelect: 'none',
    cursor: 'grab'
  },
  dragHandle: {
    color: '#9E9E9E'
  },
  position: {
    minWidth: 20,
    fontSize: 13,
    fontWeight: 600,
    color: '#9E9E9E'
  },
  rowImage: {
    width: 40,
    height: 40,
    borderRadius: 8,
    objectFit: 'cover'
  },
  rowImagePlaceholder: {
    width: 40,
    height: 40,
    borderRadius: 8,
    backgroundColor: '#F0F0F0'
  },
  rowText: {
    flex: 1,
    minWidth: 0
  },
  rowTitle: {
    fontWeight: 600,
    fontSize: 14
  },
  rowSubtitle: {
    fontSize: 12,
    opacity: 0.6
  },
  removeButton: {
    minWidth: 32,
    color: '#B0B0B0'
  },
  emptyText: {
    textAlign: 'left',
    marginLeft: '4%',
    marginTop: 12,
    fontSize: 14,
    opacity: 0.7
  }
}))

export default useStyles
